import React, { Component } from "react";
import { View } from "react-native";
import { Text } from "react-native-elements";
import { Image } from "react-native-elements/dist/image/Image";
import chatStyles from "../styles/chatStyles";

class PolicyQuoteWidget extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  convertDate = (str) => {
    const date = str.split(" ");
    return [date[2], date[1], date[3].toString().substr(2, 2)].join("-");
  };

  componentDidMount() {}

  render() {
    const { policyQuoteWidget, botMessage } = this.props;
    return (
      <View style={chatStyles.widgetWrapper}>
        <View style={chatStyles.widgetBody}>
          <View style={chatStyles.quoteWidgetHeader}>
            <Image
              style={chatStyles.quoteWidgetHeaderImage}
              source={require("../../assets/images/approved-payment.png")}
            ></Image>
            <Text style={chatStyles.quoteWidgetHeaderText}>
              {policyQuoteWidget.header}
            </Text>
          </View>

          <Text style={chatStyles.policySummaryText}>POLICY SUMMARY</Text>

          <View style={chatStyles.widgetContainer}>
            <View style={chatStyles.widgetBox}>
              <Text style={[chatStyles.widgetHeader, chatStyles.fontSize11]}>
                Zip/Post Code
              </Text>
              <Text style={[chatStyles.widgetValue, chatStyles.fontSize11]}>
                {policyQuoteWidget.postcode}
              </Text>
            </View>

            <View style={chatStyles.widgetBox}>
              <Text style={[chatStyles.widgetHeader, chatStyles.fontSize11]}>
                Policy Holder
              </Text>
              <Text style={[chatStyles.widgetValue, chatStyles.fontSize11]}>
                {policyQuoteWidget.name}
              </Text>
            </View>
            <View style={chatStyles.widgetBox}>
              <Text style={[chatStyles.widgetHeader, chatStyles.fontSize11]}>
                Type Of Policy
              </Text>
              <Text style={[chatStyles.widgetValue, chatStyles.fontSize11]}>
                {policyQuoteWidget.typeOfPolicy}
              </Text>
            </View>

            <View style={[chatStyles.widgetBox, chatStyles.width50Percent]}>
              <Text style={[chatStyles.widgetHeader, chatStyles.fontSize11]}>
                Property Details
              </Text>

              <Text style={[chatStyles.widgetHeader, chatStyles.fontSize11]}>
                {`Number Of Bedrooms: `}
                <Text style={chatStyles.policyWidgetValue}>
                  {policyQuoteWidget.bedrooms}
                </Text>
              </Text>

              <Text style={[chatStyles.widgetHeader, chatStyles.fontSize11]}>
                {`Type Of Wall Material: `}
                <Text style={chatStyles.policyWidgetValue}>
                  {policyQuoteWidget.typeOfWall}
                </Text>
              </Text>

              <Text style={[chatStyles.widgetHeader, chatStyles.fontSize11]}>
                {`Property Construction Year: `}
                <Text style={chatStyles.policyWidgetValue}>
                  {policyQuoteWidget.propertConstructionyear}
                </Text>
              </Text>

              <Text style={[chatStyles.widgetHeader, chatStyles.fontSize11]}>
                {`Type Of Building: `}
                <Text style={chatStyles.policyWidgetValue}>
                  {policyQuoteWidget.typeOfBuilding}
                </Text>
              </Text>

              <Text style={[chatStyles.widgetHeader, chatStyles.fontSize11]}>
                {`Any History Of Subsidence, Landslip: `}
                <Text style={chatStyles.policyWidgetValue}>
                  {policyQuoteWidget.histryOfSubsidenceLandslip}
                </Text>
              </Text>

              <Text style={[chatStyles.widgetHeader, chatStyles.fontSize11]}>
                {`Roof Shape: `}
                <Text style={chatStyles.policyWidgetValue}>
                  {policyQuoteWidget.roofShape}
                </Text>
              </Text>
            </View>

            <View style={[chatStyles.widgetBox, chatStyles.width50Percent]}>
              <Text style={[chatStyles.widgetHeader, chatStyles.fontSize11]}>
                Policy Information
              </Text>
              <Text style={[chatStyles.widgetHeader, chatStyles.fontSize11]}>
                {`Quote No: `}
                <Text style={chatStyles.policyWidgetValue}>
                  {policyQuoteWidget.quote}
                </Text>
              </Text>
              <Text style={[chatStyles.widgetHeader, chatStyles.fontSize11]}>
                {`Policy Creation Date: `}
              </Text>
              <Text style={chatStyles.policyWidgetValue}>
                {this.convertDate(policyQuoteWidget.creationDate)}
              </Text>
              <Text style={[chatStyles.widgetHeader, chatStyles.fontSize11]}>
                {`Policy Effective Date: `}
              </Text>
              <Text style={chatStyles.policyWidgetValue}>
                {this.convertDate(policyQuoteWidget.effectivedate)}
              </Text>
              <Text style={[chatStyles.widgetHeader, chatStyles.fontSize11]}>
                {`Policy Expiration Date: `}
              </Text>
              <Text style={chatStyles.policyWidgetValue}>
                {this.convertDate(policyQuoteWidget.expirationDate)}
              </Text>
              <Text style={[chatStyles.widgetHeader, chatStyles.fontSize11]}>
                {`Rebuild Cost: `}
                <Text style={chatStyles.policyWidgetValue}>
                  {policyQuoteWidget.rebuildCost}
                </Text>
              </Text>
            </View>
          </View>

          <View style={chatStyles.quoteAmountWrapper}>
            <Text style={chatStyles.quoteAmount}>
              Annual Policy Premium £{policyQuoteWidget.premium}
            </Text>
            {policyQuoteWidget.monthly != 0 && (
              <Text style={chatStyles.quoteAmountMonthly}>
                Monthly Premium Deduction £{policyQuoteWidget.monthly}
              </Text>
            )}
          </View>
        </View>
        <Text style={chatStyles.chatTime}>
          {new Date(botMessage.sentAt).toLocaleString([], {
            hour12: false,
            hour: "2-digit",
            minute: "2-digit",
          })}
        </Text>
      </View>
    );
  }
}
export default PolicyQuoteWidget;
